import { render, staticRenderFns } from "./LocationEventTypeTable.vue?vue&type=template&id=1b836c62"
import script from "./LocationEventTypeTable.vue?vue&type=script&lang=js"
export * from "./LocationEventTypeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports